// src/utils/models/proposalModel.js

export const PROPOSAL_STATUS = {
  PENDING: 'pending',
  CREATED: 'created',
  SENT: 'sent',
  MODIFICATION: 'modification',
  REJECTED: 'rejected',
  ACCEPTED: 'accepted'
};

export const PROPOSAL_STATUS_LABELS = {
  pending: 'Pendiente',
  created: 'En proceso',
  sent: 'Enviada',
  modification: 'Modificación',
  rejected: 'Rechazada',
  accepted: 'Aceptada'
};

export const createProposal = (data) => ({
  id: '',
  
  // Datos básicos
  title: data.title || '',
  description: data.description || '',
  
  // Dirección (opcional, se coge del cliente)
  address: {
    street: data.address?.street || '',
    city: data.address?.city || '',
    province: data.address?.province || '',
    zipCode: data.address?.zipCode || '',
    country: data.address?.country || 'España',
  },
  
  // Cliente
  clientId: data.clientId || '',
  clientName: data.clientName || '',
  clientEmail: data.clientEmail || '',
  
  // Canal de entrada
  entryChannel: data.entryChannel || '',
  entryChannelContactId: data.entryChannelContactId || '',
  commercialPercentage: data.commercialPercentage || '',
  
  // Factura
  hasInvoice: data.hasInvoice || false,
  invoiceLink: data.invoiceLink || '',
  
  // Archivos
  files: data.files || [],
  
  // Versiones
  version: data.version || '1.0',
  versions: data.versions || [],
  
  // Fechas
  reminderDate: data.reminderDate || '',
  createdAt: data.createdAt || new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  
  // Estado
  status: data.status || PROPOSAL_STATUS.PENDING,
  
  // Metadata
  notes: data.notes || '',
  createdBy: '',
  isActive: true
});